import Missile, { MissileParams } from '../missile';
import Projectile, { ProjectileParams } from '../projectile';
import Weapon, { WeaponParams } from './weapon';

export interface MissileLauncherParams extends WeaponParams {
  projectileParams?: MissileParams;
  ammo?: number;
  timeBetweenReloads?: number;
}

export default class MissileLauncher extends Weapon implements MissileLauncherParams {
  projectileParams?: MissileParams;
  ammo: number = 0;
  timeBetweenReloads: number = 0;

  timeBeBeforeNextReload: number;
  ammoMax: number;

  constructor(params: MissileLauncherParams)
  {
    super(params);
    this.applyParams(params);
    this.ammoMax = this.ammo;
    this.timeBeBeforeNextReload = this.timeBetweenReloads;
  }

  updateCooldown(modifier: number): void
  {
    super.updateCooldown(modifier);
    this.timeBeBeforeNextReload -= (modifier * 1000);
    if (this.timeBeBeforeNextReload <= 0)
    {
      this.ammo = Math.min(this.ammo + 1, this.ammoMax);
      this.timeBeBeforeNextReload = this.timeBetweenReloads;
    }
  }

  createProjectile(): Projectile
  {
    this.timeBeforeNextShot = this.timeBetweenShots;
    this.ammo --;
    /* Create new projectile */
    return new Missile({
      ... this.projectileParams,
      ...this.getProjectileAdditionalParams()
    } as MissileParams)
      .create() as Projectile
    ;
  }

  shoot(): void
  {
    if (this.ammo <= 0)
      return;

    super.shoot();
  }
}
